import React from "react";
import {
  IoCloseOutline,
  IoExitOutline,
  IoMenuOutline,
  IoPersonOutline,
} from "react-icons/io5";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

// Assets
// import premiumImg from "../assets/core/img/premium_logo.png";
// import soundImg from "../assets/core/img/sound.png";
// import languageImg from "../assets/core/img/language.png";

// Hook
import { useAuth } from "../hooks/useAuth";

// Helper
import { checkAuth, handleSignOut } from "../helpers/authHelper";

function LeftLink({ view }) {
  const location = useLocation();

  const { auth } = useAuth();

  const { user } = auth;
  const { game } = location.state || {};

  const activeLink = (isActive, view) => {
    let _active = isActive ? "text-retro-flame" : "text-black";
    let mobile = `uppercase text-xl ${_active} w-full p-2 last:mr-0 hover:bg-retro-grey`;

    return view === "mobile"
      ? mobile
      : `uppercase text-xl ${_active} mr-4 last:mr-0`;
  };

  const mobile =
    "bg-white shadow-md shadow-black w-full md:hidden flex flex-col justify-between items-center font-rounded font-medium text-center";

  return (
    <nav
      className={
        view === "mobile"
          ? mobile
          : "w-full hidden md:flex flex-row justify-between items-center font-rounded font-medium"
      }
    >
      <NavLink
        className={({ isActive }) => activeLink(isActive, view)}
        to="/games"
      >
        Home
      </NavLink>

      {game ? (
        <NavLink
          className={({ isActive }) => activeLink(isActive, view)}
          to={`/g/${game?.game_id}/leaderboard`}
          state={{ game }}
        >
          Leaderboard
        </NavLink>
      ) : null}

      <NavLink
        className={({ isActive }) => activeLink(isActive, view)}
        to={`/p/${user?.display_name}/stats`}
      >
        Stats
      </NavLink>

      <NavLink
        className={({ isActive }) => activeLink(isActive, view)}
        to="/about"
      >
        About
      </NavLink>
    </nav>
  );
}

function RightLink() {
  const navigate = useNavigate();

  const { auth, setAuth } = useAuth();

  const { name, display_name } = auth.user || {};

  const { refresh_token_expired } = checkAuth(auth.token);

  return (
    <nav className="flex justify-between items-center font-retro-rounded">
      {/* {!refresh_token_expired ? (
        <img
          className="w-6 h-6 lg:w-8 lg:h-8 mr-4 last:mr-0 cursor-pointer"
          src={premiumImg}
          alt=""
        />
      ) : null} */}

      {/* {!refresh_token_expired ? (
        <img
          className="w-6 h-6 lg:w-8 lg:h-8 mr-4 last:mr-0 cursor-pointer"
          src={soundImg}
          alt=""
        />
      ) : null} */}

      {/* <img
        className="w-6 h-6 lg:w-8 lg:h-8 mr-4 last:mr-0 cursor-pointer"
        src={languageImg}
        alt=""
      /> */}

      {!refresh_token_expired ? (
        <NavLink
          className="w-6 h-6 lg:w-8 lg:h-8 mr-4 last:mr-0 cursor-pointer"
          to={`/p/${display_name}`}
        >
          <IoPersonOutline className="w-full h-full" aria-label={name} />
        </NavLink>
      ) : null}

      {!refresh_token_expired ? (
        <IoExitOutline
          className="w-6 h-6 lg:w-8 lg:h-8 mr-4 last:mr-0 cursor-pointer"
          onClick={() => handleSignOut(auth, navigate, setAuth)}
        />
      ) : null}

      {!refresh_token_expired ? (
        <span className="mr-4 last:mr-0 pointer-events-none uppercase font-retro-sabo text-xl text-retro-flame">
          {display_name?.length > 10
            ? `${display_name.slice(0, 10)}...`
            : display_name}
        </span>
      ) : null}
    </nav>
  );
}

export default function NavBar() {
  const { auth } = useAuth();

  const { refresh_token_expired } = checkAuth(auth.token);

  const [showMenu, setShowMenu] = React.useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <header
      className={`h-14 px-[3vw] flex flex-col justify-between ${
        showMenu ? "border-b-2 border-black" : null
      }`}
    >
      <div className="w-full h-full py-3 flex justify-between items-center">
        {/* Left Links */}
        <div className="hidden md:block">
          {!refresh_token_expired ? <LeftLink /> : null}
        </div>

        {/* Toggle Menu */}
        <div className="md:hidden">
          {!refresh_token_expired ? (
            showMenu ? (
              <IoCloseOutline
                className="w-8 h-8 text-retro-flame cursor-pointer"
                onClick={toggleMenu}
              />
            ) : (
              <IoMenuOutline
                className="w-8 h-8 text-retro-flame cursor-pointer"
                onClick={toggleMenu}
              />
            )
          ) : null}
        </div>

        {/* Right Links */}
        <div className="">
          <RightLink />
        </div>
      </div>

      <div className="w-full h-0 relative md:hidden">
        {/* Mobile Links */}
        <div
          className={`w-full absolute top-0 border-black z-50
        ${showMenu ? "block border-t-2" : "hidden"}
        md:block`}
        >
          {!refresh_token_expired ? <LeftLink view="mobile" /> : null}
        </div>
      </div>
    </header>
  );
}
